import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { ConverterService, OccEndpointsService } from '@spartacus/core'
import {
  MB_PRODUCT_DATA_IMAGE_TAB_NORMALIZER,
  MbProductDataImagesTabAdapter
} from '../connectors/product-data-images'

@Injectable({
  providedIn: 'root'
})
export class MbOccProductDataImagesTabAdapter implements MbProductDataImagesTabAdapter {

  constructor (protected http: HttpClient,
              protected occEndpoints: OccEndpointsService,
              protected converter: ConverterService) {
  }

  load (productCode: string, maxCount?: number) {
    return this.http.get(this.getEndpoint(productCode, maxCount)).pipe(
      this.converter.pipeable(MB_PRODUCT_DATA_IMAGE_TAB_NORMALIZER)
    )
  }

  protected getEndpoint (code: string, maxCount?: number) {
    return this.occEndpoints.buildUrl(
      'productTabProductDataImages',
      {
        urlParams: { productCode: code },
        queryParams: { maxCount },
      }
    )
  }
}
